export const th = {
    // ─── Navigation (Sidebar) ───────────────────────────────
    navDashboard: 'แดชบอร์ด',
    navTransactions: 'ธุรกรรม',
    navStatistics: 'สถิติ',
    navReports: 'สรุป & งบการเงิน',
    navReportsHint: 'สถิติภาพรวม และออกสเตทเม้นท์',
    navBudget: 'งบดุล',
    navSettings: 'ตั้งค่า',

    // ─── Common ─────────────────────────────────────────────
    income: 'รายได้',
    expense: 'รายจ่าย',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    delete: 'ลบ',
    edit: 'แก้ไข',
    add: 'เพิ่ม',
    reset: 'รีเซ็ต',
    export: 'ส่งออก',
    loading: 'กำลังโหลด…',
    saving: 'กำลังบันทึก…',
    error: 'เกิดข้อผิดพลาด',
    saveSuccess: 'บันทึกรายการสำเร็จ',
    updateSuccess: 'อัปเดตรายการสำเร็จ',
    deleteSuccess: 'ลบรายการสำเร็จ',
    saveFailed: 'การบันทึกไม่สำเร็จ',
    deleteFailed: 'การลบไม่สำเร็จ',
    invalidAmount: 'กรุณากรอกจำนวนเงินให้ถูกต้องและมากกว่า 0',
    storageMode: 'โหมดการบันทึก',
    storageDesktop: 'เดสก์ท็อปแอป (SQLite)',
    storageBrowser: 'เว็บเบราว์เซอร์ (localStorage)',
    noData: 'ไม่มีข้อมูลแสดง',
    period: 'ช่วงเวลานี้',
    allTypes: 'ทุกประเภท',
    allCategories: 'ทุกหมวดหมู่',
    confirmDelete: 'แน่ใจหรือไม่ว่าต้องการลบธุรกรรมนี้?',

    // ─── Dashboard ──────────────────────────────────────────
    dashboardTitle: 'รายรับ-รายจ่าย',
    dashboardSubtitle: 'ภาพรวมการเงินของคุณ',
    totalIncome: 'รายได้รวม',
    totalExpense: 'รายจ่ายรวม',
    netBalance: 'ยอดสุทธิ',
    recentTransactions: 'ธุรกรรมล่าสุด',
    lastEntries: '{n} รายการล่าสุด',
    noTransactionsYet: 'ยังไม่มีธุรกรรม',
    addFirstTransaction: 'เพิ่มธุรกรรมแรกของคุณเพื่อเริ่มต้น',

    // ─── Transactions ────────────────────────────────────────
    transactionsTitle: 'ธุรกรรมการเงิน',
    totalRecords: '{n} รายการทั้งหมด',
    newTransaction: '+ เพิ่มธุรกรรม',
    editTransaction: 'แก้ไขธุรกรรม',
    addTransactionBtn: 'เพิ่มรายการ',
    updateBtn: 'อัปเดต',
    cancelEdit: 'ยกเลิกการแก้ไข',
    formType: 'ประเภท',
    formAmount: 'จำนวนเงิน',
    formCategory: 'หมวดหมู่',
    formDate: 'วันที่',
    formDescription: 'รายละเอียด (ไม่บังคับ)',
    formDescPlaceholder: 'เพิ่มหมายเหตุ…',
    formCategoryPlaceholder: 'เช่น อาหาร, เดินทาง',
    filters: 'ค้นหารายการ',
    filterSearch: 'ค้นหา',
    filterSearchPlaceholder: 'หมวดหมู่หรือหมายเหตุ…',
    filterType: 'ประเภท',
    filterCategory: 'หมวดหมู่',
    filterFrom: 'จากวันที่',
    filterTo: 'ถึงวันที่',
    showingOf: 'แสดง {shown} จาก {total} รายการ',
    noResults: 'ไม่พบผลลัพธ์',
    noResultsHint: 'ลองปรับตัวกรองใหม่',

    // ─── Scan Slip ───────────────────────────────────────────
    scanSlip: 'สแกนสลิป',
    scanBill: 'สแกนบิล',
    scanBillHint: 'AI จะอ่านทุกรายการและแยกหมวดหมู่ให้อัตโนมัติ',
    scanSlipTitle: 'สแกนสลิปใบเสร็จ',
    scanSlipDesc: 'ถ่ายรูปหรืออัปโหลดสลิปเพื่อเติมข้อมูลอัตโนมัติ',
    scanSlipUpload: 'อัปโหลดรูป',
    scanSlipCamera: 'ถ่ายรูป',
    scanSlipScan: 'อ่านสลิป',
    scanSlipProcessing: 'กำลังอ่านข้อความ…',
    scanSlipSuccess: 'อ่านข้อมูลสำเร็จ — ตรวจสอบและบันทึก',
    scanSlipFailed: 'อ่านข้อมูลไม่ได้ครบ — กรอกเพิ่มเติมได้เลย',
    scanSlipNoImage: 'กรุณาเลือกรูปภาพก่อน',
    scanSlipTapToSelect: 'แตะเพื่อเลือกรูปสลิป',
    scanSlipFormats: 'รองรับ JPG, PNG, HEIC และรูปถ่ายจากกล้อง',
    scanSlipPreviewTitle: 'ตรวจสอบและแก้ไขข้อมูลก่อนบันทึก',
    scanSlipUse: 'ใช้ข้อมูลนี้',

    // ─── Statistics ──────────────────────────────────────────
    statisticsTitle: 'สถิติ',
    statisticsSubtitle: 'กราฟและการวิเคราะห์การเงินของคุณ',
    monthlyTrend: 'แนวโน้มรายเดือน',
    incomeVsExpense: 'รายได้เทียบรายจ่าย',
    expensesByCategory: 'รายจ่ายตามหมวดหมู่',
    incomeByCategory: 'รายได้ตามหมวดหมู่',
    summaryByCategory: 'สรุปตามหมวดหมู่',

    // ─── Reports ─────────────────────────────────────────────
    reportsTitle: 'สรุปภาพรวม & งบการเงิน',
    reportsSubtitle: 'รายงานสรุปทางการเงิน และสถิติภาพรวม',
    reportsDesc: 'รวมกราฟวิเคราะห์สถิติ รายงานงบดุล และการออกสเตทเม้นท์ในหน้าเดียว',
    customizeStatementBtn: '⚙️ ปรับแต่งสเตทเม้นท์ / ส่งออก',
    exportBtn: '↓ ส่งออก',
    subtabAnalytics: 'กราฟสถิติ & วิเคราะห์สัดส่วน',
    subtabFinancials: 'รายงานงบดุล & ออกสเตทเม้นท์',
    monthly: 'รายเดือน',
    quarterly: 'รายไตรมาส',
    labelMonth: 'เดือน',
    labelQuarter: 'ไตรมาส',
    labelYear: 'ปี',
    exportReport: 'ส่งออก',
    categoryBreakdown: 'รายละเอียดตามหมวดหมู่',
    noDataPeriod: 'ไม่มีข้อมูลสำหรับช่วงเวลานี้',
    q1: 'Q1 (ม.ค.–มี.ค.)',
    q2: 'Q2 (เม.ย.–มิ.ย.)',
    q3: 'Q3 (ก.ค.–ก.ย.)',
    q4: 'Q4 (ต.ค.–ธ.ค.)',
    txCount: 'จำนวนรายการ',
    expenseVsIncome: 'รายได้เทียบรายจ่ายตามหมวดหมู่',
    clickRowDetails: 'คลิกแถวเพื่อดูรายละเอียดเพิ่มเติม',
    items: 'รายการ',
    showTable: 'แสดงตารางธุรกรรมทั้งหมด',
    hideTable: 'ซ่อนตารางธุรกรรม',
    allTransactionsThisPeriod: 'รายการธุรกรรมทั้งหมดในงวดนี้',
    exportSuccess: 'ส่งออกข้อมูลสำเร็จ',
    exportFailed: 'เกิดข้อผิดพลาดในการส่งออกข้อมูล',

    // ─── Budget ──────────────────────────────────────────────
    budgetTitle: 'งบดุล',
    budgetSubtitle: 'กำหนดและติดตามวงเงินค่าใช้จ่ายตามหมวดหมู่',
    labelSelectMonth: 'เดือน',
    setBudget: 'ตั้งงบประมาณ',
    setBudgetForm: 'กำหนดวงเงินงบประมาณ',
    labelBudgetCategory: 'หมวดหมู่',
    labelBudgetLimit: 'วงเงินงบประมาณ (บาท)',
    labelAlertAt: 'เตือนที่ (%)',
    alertHint: 'จะแจ้งเตือนเมื่อค่าใช้จ่ายถึง {pct}% ของวงเงิน',
    setBudgetBtn: 'ตั้งงบประมาณ',
    budgetStatus: 'สถานะงบประมาณ',
    statusExceeded: 'เกินงบ',
    statusWarning: 'ใกล้เต็ม',
    statusOnTrack: 'ตามแผน',
    remaining: 'คงเหลือ',
    alertAtLabel: 'เตือนที่',
    noBudgetsYet: 'ยังไม่มีงบประมาณ',
    noBudgetsHint: 'คลิก "+ ตั้งงบประมาณ" เพื่อเพิ่มรายการแรก',
    selectCategory: 'เลือกหมวดหมู่',
    budgetTips: 'เคล็ดลับ',
    tip1: 'ตั้งวงเงินที่สมเหตุสมผลตามการใช้จ่ายจริง',
    tip2: 'การแจ้งเตือนช่วยให้จับสัญญาณเกินงบได้เร็ว',
    tip3: 'ทบทวนและปรับงบทุกเดือน',
    tip4: 'ตามแผน · ใกล้เต็ม · เกินงบ',
    deleteBudgetConfirm: 'ต้องการลบงบประมาณของ {category} ใช่หรือไม่?',

    // ─── Settings ────────────────────────────────────────────
    settingsTitle: 'ตั้งค่า',
    settingsSubtitle: 'การตั้งค่าและจัดการข้อมูล',
    appearance: 'รูปลักษณ์',
    darkMode: 'โหมดมืด',
    darkModeOn: 'กำลังใช้งานโหมดมืด',
    darkModeOff: 'เปลี่ยนเป็นโหมดมืด',
    languageLabel: 'ภาษา',
    languageCurrent: 'ภาษาไทย',
    exportBackup: 'ส่งออกและสำรองข้อมูล',
    exportExcelTitle: 'ส่งออก Excel',
    exportExcelDesc: 'ดาวน์โหลดธุรกรรมทั้งหมดเป็นไฟล์ Excel',
    exportExcelBtn: 'ส่งออก Excel',
    backupTitle: 'สำรองฐานข้อมูล',
    backupDesc: 'สร้างสำเนาสำรองของฐานข้อมูลในเครื่อง',
    backupBtn: 'สำรองข้อมูล',
    restoreTitle: 'คืนค่าฐานข้อมูล',
    restoreDesc: 'แทนที่ข้อมูลปัจจุบันจากไฟล์สำรอง',
    restoreBtn: 'คืนค่า',
    restoreConfirm: 'การดำเนินการนี้จะแทนที่ข้อมูลปัจจุบัน ต้องการดำเนินการต่อหรือไม่?',
    databaseSection: 'ฐานข้อมูล',
    dbCurrentPath: 'ไฟล์ฐานข้อมูลปัจจุบัน',
    dbDefault: '(ค่าเริ่มต้น)',
    dbCustom: '(กำหนดเอง)',
    dbChooseBtn: 'เลือกไฟล์ฐานข้อมูล',
    dbChooseDesc: 'เลือกไฟล์ .db ที่ต้องการใช้งาน',
    dbResetBtn: 'ใช้ฐานข้อมูลเริ่มต้น',
    dbResetDesc: 'กลับไปใช้ฐานข้อมูลเริ่มต้นของแอป',
    dbRestartNote: 'กรุณารีสตาร์ทแอปเพื่อใช้ฐานข้อมูลใหม่',
    aboutTitle: 'เกี่ยวกับ',
    appName: 'MoneyMa',
    appTagline: 'จดรายรับรายจ่าย โดยไม่ต้องพิมพ์',
    // {v} = เวอร์ชันจาก package.json (ส่งมาตอน build) — ห้ามเขียนเลขตายไว้ตรงนี้
    appVersion: 'เวอร์ชัน {v}',
    appStack: 'React · Capacitor · Supabase · Gemini',
    featuresTitle: 'ฟีเจอร์',
    featureList: [
        'สแกนสลิปและใบเสร็จ',
        'ภาพรวมแดชบอร์ด',
        'บันทึกรายรับรายจ่าย',
        'งบประมาณรายหมวด',
        'กราฟและสถิติ',
        'ค้นหาและกรองย้อนหลัง',
        'ส่งออก Excel และ PDF',
        'ซิงก์ข้ามอุปกรณ์',
        'ไทย-อังกฤษ และโหมดมืด',
    ],

    // ─── Table Headers ───────────────────────────────────────
    viewCards: 'การ์ด',
    viewTable: 'ตาราง',
    thDate: 'วันที่',
    thCategory: 'หมวดหมู่',
    thDescription: 'รายละเอียด',
    thType: 'ประเภท',
    thAmount: 'จำนวนเงิน',
    thActions: 'จัดการ',
    thIncome: 'รายได้',
    thExpense: 'รายจ่าย',
    thNet: 'สุทธิ',

    // ─── Authentication ──────────────────────────────────────
    loginTitle: 'เข้าสู่ระบบ',
    signInBtn: 'เข้าสู่ระบบ',
    signingIn: 'กำลังเข้าสู่ระบบ...',
    registerTitle: 'สร้างบัญชี',
    signUpBtn: 'สร้างบัญชี',
    signingUp: 'กำลังสร้างบัญชี...',
    emailLabel: 'ที่อยู่อีเมล',
    emailPlaceholder: 'your.email@example.com',
    passwordLabel: 'รหัสผ่าน',
    passwordPlaceholder: '••••••••',
    passwordConfirmLabel: 'ยืนยันรหัสผ่าน',
    passwordMinLength: 'รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร',
    passwordMatch: 'รหัสผ่านไม่ตรงกัน',
    firstNameLabel: 'ชื่อจริง',
    firstNamePlaceholder: 'John',
    lastNameLabel: 'นามสกุล',
    lastNamePlaceholder: 'Doe',
    rememberMe: 'จำฉันไว้',
    forgotPassword: 'ลืมรหัสผ่าน?',
    noAccount: 'ยังไม่มีบัญชี?',
    haveAccount: 'มีบัญชีแล้ว?',
    signUpHere: 'สมัครสมาชิกที่นี่',
    signInHere: 'เข้าสู่ระบบที่นี่',
    continueGuest: 'ทดลองใช้งานโดยไม่เข้าสู่ระบบ',
    demoMode: 'หรือทดลองใช้ฟีเจอร์ก่อนสมัคร',
    guestSubtitle: 'บันทึกข้อมูลในเครื่องทันที สามารถผูกบัญชีเพื่อซิงค์ Cloud ได้ทุกเมื่อ',
    invalidEmail: 'ที่อยู่อีเมลไม่ถูกต้อง',
    emailRequired: 'กรุณากรอกที่อยู่อีเมล',
    passwordRequired: 'กรุณากรอกรหัสผ่าน',
    firstNameRequired: 'กรุณากรอกชื่อจริง',
    lastNameRequired: 'กรุณากรอกนามสกุล',
    loginFailed: 'การเข้าสู่ระบบผิดพลาด กรุณาตรวจสอบข้อมูลประจำตัวของคุณ',
    registerFailed: 'การสมัครสมาชิกผิดพลาด',
    signOutBtn: 'ออกจากระบบ',
    signInWithGoogle: 'เข้าสู่ระบบด้วย Google',
    signInWithApple: 'เข้าสู่ระบบด้วย Apple',
    orContinueWith: 'หรือเข้าสู่ระบบด้วย',

    // ─── Premium ─────────────────────────────────────────────
    premiumTitle: 'MoneyMa Premium',
    premiumBack: 'กลับ',
    oneTime: 'จ่ายครั้งเดียว',
    oneTimePrice: '$14.99',
    oneTimeSub: 'จ่ายครั้งเดียว ใช้งานได้ตลอดไป',
    lifetime: 'ใช้งานตลอดชีพ',
    freeUpdates: 'อัปเดตฟรีตลอดไป',
    localDevice: 'บันทึกข้อมูลในตัวเครื่อง',
    backupRestore: 'สำรองและคืนค่าข้อมูล',
    subscription: 'สมัครสมาชิก',
    subPriceMonth: '$4.99/เดือน',
    subPriceYear: '$39.99/ปี (ประหยัด 33%)',
    recommended: 'แนะนำ',
    onlineDb: 'ฐานข้อมูลออนไลน์',
    cloudBackup: 'สำรองข้อมูลบนคลาวด์',
    support: 'ทีมงานซัพพอร์ตต่อเนื่อง',
    multiPlatform: 'รองรับ Web, Mobile, Desktop',
    whyUpgrade: 'ทำไมต้องอัปเกรดเป็น Premium?',
    benefit1: 'ไม่จำกัดจำนวนบัญชีและหมวดหมู่',
    benefit2: 'สแกนบิลและสลิปด้วย AI จุใจถึง 1,500 ครั้ง/เดือน',
    benefit3: 'ซิงค์ข้อมูลและสำรองข้อมูลข้ามอุปกรณ์อัตโนมัติ',
    benefit4: 'สนับสนุนผู้พัฒนาให้อัปเดตแอปต่อไป',
    additionalPayment: 'ช่องทางชำระเงินเพิ่มเติม',
    manualPaymentInfo: 'โอนแล้วส่งหลักฐานเพื่อให้ทีมช่วยเปิดสิทธิ์ให้',
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว!',
    contactUs: 'ช่องทางติดต่อ',
    restorePurchases: 'กู้คืนการซื้อ (Restore Purchases)',
    premiumSuccess: '🎉 ยินดีด้วย! คุณได้รับการอัปเกรดเป็นสมาชิกระดับ Premium แล้ว',
    premiumStatus: 'คุณเป็นสมาชิกระดับ Premium แล้ว',
    premiumStatusDesc: 'ขอบคุณที่สนับสนุนเรา! คุณสามารถใช้งานทุกฟีเจอร์ได้อย่างไร้ขีดจำกัด',
    packageNotFound: 'ไม่พบแพ็กเกจ กรุณาลองใหม่อีกครั้ง หรือติดต่อเรา',
    restoreSuccess: 'กู้คืนการซื้อสำเร็จ! คุณเป็นสมาชิกระดับ Premium',
    restoreFailed: 'ไม่พบข้อมูลการเป็นสมาชิก Premium ในบัญชีนี้',
    loadingPackages: 'กำลังโหลดแพ็กเกจ...',
    buyNow: 'สมัคร {price}',
    downloadApp: 'ดาวน์โหลดแอปบน Google Play',
    testSystem: 'ทดสอบระบบ',

    // ── i18n fix 5 ส.ค. 2026: คีย์ที่โค้ดเรียกใช้แต่ยังไม่มีในไฟล์แปล ──
    userProfile: 'โปรไฟล์ผู้ใช้',
    notLoggedInProfile: 'เข้าสู่ระบบเพื่อดูโปรไฟล์และโควตา AI ของคุณ',
    loginToSync: 'เข้าสู่ระบบ',
    aiUsageTitle: 'โควตา AI สแกน',
    quotaDaily: 'รายวัน',
    quotaMonthly: 'รายเดือน',
    quotaRemaining: 'คงเหลือ',
    scanQuotaTitle: 'โควตาสแกนฟรี',
    scanQuotaLeft: 'เหลืออีก {n} จาก {max} ครั้ง ({scope})',
    scanQuotaOut: 'ใช้โควตาสแกนฟรีครบแล้ว — อัปเกรดเพื่อสแกนต่อได้ไม่จำกัด',

    syncTitle: 'ซิงค์ข้อมูลบนคลาวด์',
    syncDesc: 'อัปโหลดและดาวน์โหลดข้อมูลธุรกรรมกับเซิร์ฟเวอร์',
    syncStatus: 'สถานะการซิงค์',
    syncNowBtn: 'ซิงค์ข้อมูล',
    syncStateSyncing: 'กำลังซิงค์',
    syncStateFailed: 'ไม่สำเร็จ',
    syncStateUpToDate: 'เป็นปัจจุบัน',
    signInToSync: 'เข้าสู่ระบบเพื่อซิงค์ข้อมูล',
    signInToSyncDesc: 'ข้อมูลจะเก็บไว้ในเครื่องนี้จนกว่าคุณจะเข้าสู่ระบบ',
    accountSection: 'บัญชีผู้ใช้',
    signOutDesc: 'ข้อมูลจะถูกซิงค์ขึ้นคลาวด์ก่อนออกจากระบบ',
    signOutConfirm: 'ออกจากระบบใช่ไหม ข้อมูลจะถูกซิงค์ขึ้นคลาวด์ก่อน',

    // ── ลบบัญชี (Google Play บังคับให้มีทั้งในแอปและบนเว็บ) ──
    deleteAccountTitle: 'ลบบัญชีถาวร',
    deleteAccountDesc: 'ลบบัญชีและข้อมูลทั้งหมดออกจากเซิร์ฟเวอร์อย่างถาวร กู้คืนไม่ได้',
    deleteAccountBtn: 'ลบบัญชี',
    deleteAccountWarning: 'การลบบัญชีจะลบรายการทั้งหมด งบประมาณ ประวัติการซิงค์ และข้อมูลการสมัครสมาชิกอย่างถาวร กู้คืนไม่ได้\n\nแนะนำให้ส่งออกข้อมูลเป็น Excel เก็บไว้ก่อน\n\nต้องการไปต่อหรือไม่',
    deleteAccountConfirmPrompt: 'พิมพ์คำว่า ลบบัญชี เพื่อยืนยัน',
    deleteAccountConfirmWord: 'ลบบัญชี',
    deleteAccountMismatch: 'ข้อความยืนยันไม่ตรง ยกเลิกการลบแล้ว',
    deleteAccountSubActive: 'บัญชีนี้มีสมาชิกที่ยังใช้งานอยู่ การลบบัญชีไม่ได้ยกเลิกการเรียกเก็บเงิน กรุณายกเลิกสมาชิกที่หน้าการสมัครสมาชิกของ Google Play ก่อน',
    deleteAccountSuccess: 'ลบบัญชีและข้อมูลทั้งหมดเรียบร้อยแล้ว',
    deleteAccountFailed: 'ลบบัญชีไม่สำเร็จ กรุณาลองใหม่ หรือติดต่อ naiguitarfolk@gmail.com',
    deleteAccountDeleting: 'กำลังลบบัญชี...',

    // ── แถบโปรโมชัน (ค่าจริงมาจาก src/config/promo.js) ──
    promoBannerTitle: 'ลดสูงสุด {pct}% สำหรับผู้สมัครใหม่',
    promoBannerDaysLeft: 'เหลืออีก {n} วัน',
    promoBannerLastDay: 'วันสุดท้ายแล้ว',
    promoBannerAria: 'ดูรายละเอียดราคาพิเศษ',

    // ── Paywall แบบ 3 ข้อเสนอ ──
    pwOffer_monthly: 'รายเดือน',
    pwOffer_yearly: '12 เดือน',
    pwOffer_lifetime: 'จ่ายครั้งเดียว',
    pwBestValue: 'คุ้มที่สุด',
    pwOneTime: 'ครั้งเดียวจบ',
    pwNoRenewal: 'ใช้ได้ตลอด ไม่มีต่ออายุ',
    pwDiscountOff: 'ลด {pct}%',
    pwFirstPeriodOnly: 'เดือนแรกเท่านั้น',
    pwSubscribe: 'สมัครสมาชิก',
    pwBuyOnce: 'ซื้อครั้งเดียว',
    pwPremium: 'Premium',
    pwPromoTerms: 'ราคาพิเศษใช้กับการสมัครรอบแรก รอบถัดไปคิดราคาปกติ · ยกเลิกได้เองตลอดเวลาที่หน้าการสมัครสมาชิกของ Google Play',
    pwScansFree: '20 ครั้ง/เดือน',
    pwHistory: 'ดูข้อมูลย้อนหลัง',
    pwHistory90: '90 วัน',
    pwBudget3: '3 หมวด',
    pwBudgetLimits: 'งบประมาณรายหมวด',
    pwExport: 'ส่งออก Excel และ PDF',
    pwCloudSync: 'ซิงก์ข้ามอุปกรณ์',
    pwAutoScan: 'สแกนจากแกลเลอรีอัตโนมัติ',
    useCloudStorage: 'ใช้ที่เก็บข้อมูลบนคลาวด์',
    useCloudStorageDesc: 'เก็บข้อมูลบนเซิร์ฟเวอร์แทนการเก็บไว้ในเครื่องอย่างเดียว',

    resetPasswordTitle: 'รีเซ็ตรหัสผ่าน',
    resetPasswordSubtitle: 'ตั้งรหัสผ่านใหม่สำหรับบัญชีของคุณ',
    sendResetLink: 'ส่งลิงก์รีเซ็ตรหัสผ่าน',
    resetLinkSent: 'ส่งลิงก์รีเซ็ตแล้ว กรุณาตรวจสอบอีเมลของคุณ',
    newPasswordLabel: 'รหัสผ่านใหม่',
    updatePasswordBtn: 'อัปเดตรหัสผ่าน',
    grandTotal: 'รวมทั้งสิ้น',
    total: 'รวม',
    thPctExpense: '% ของรายจ่าย',
    benefitsTitle: 'สิ่งที่คุณจะได้รับ',

    scanSlipCardDesc: 'อ่านสลิปโอนเงินอัตโนมัติ',
    scanBillCardDesc: 'แยกรายการจากใบเสร็จ',
    freeQuotaTitle: 'โควตาบันทึกธุรกรรมของแผนใช้งานฟรี',
    freeQuotaUsed: 'บันทึกไปแล้ว {n} จาก {max} รายการในเดือนนี้',
    upgradeToPro: 'อัปเกรดเป็น Pro',
    txLimitTitle: 'ถึงขีดจำกัดของแผนใช้งานฟรีแล้ว',
    txLimitDesc: 'แผนใช้งานฟรีบันทึกได้สูงสุด <strong>50 รายการต่อเดือน</strong> อัปเกรดเป็น Pro เพื่อบันทึกได้ไม่จำกัดและใช้ Cloud Sync',
    budgetLimitTitle: 'ถึงขีดจำกัดงบประมาณของแผนใช้งานฟรีแล้ว',
    budgetLimitDesc: 'แผนใช้งานฟรีตั้งงบประมาณได้ <strong>1 หมวดหมู่</strong> อัปเกรดเป็น Pro เพื่อตั้งงบประมาณได้ไม่จำกัด',
    userLabel: 'ผู้ใช้งาน',

    // ── สแกนสลิป / สแกนบิล ──
    autoScanTitle: 'สแกนสลิปจากคลังภาพอัตโนมัติ',
    autoScanDesc: 'เลือกรูปหลายใบ แล้ว AI จะอ่านและจัดหมวดหมู่ให้',
    chooseSlipImage: 'เลือกรูปสลิป',
    chooseNewImage: 'เลือกรูปใหม่',
    tapOrDrag: 'แตะเพื่อเลือก หรือลากไฟล์มาวาง',
    scanSlipHint: 'ใช้เวลาไม่กี่วินาที',
    scanSlipDuplicate: 'เคยสแกนแล้ว',
    slipAlt: 'สลิปโอนเงิน',
    billAlt: 'ใบเสร็จ',
    dateTime: 'วันที่และเวลา',
    sender: 'จาก',
    receiver: 'ไปยัง',
    amount: 'จำนวนเงิน',
    refId: 'เลขอ้างอิง',
    ref2: 'รหัสลูกค้า / Ref.2',
    address: 'ที่อยู่',
    slipNote: 'หมายเหตุจากสลิป',
    editBeforeSave: 'ตรวจสอบก่อนบันทึก',
    note: 'หมายเหตุ',
    noteHint: 'รายละเอียดเพิ่มเติม',
    retry: 'ลองใหม่',
    rescan: 'สแกนใหม่',
    saveItem: 'บันทึก',
    batchScanning: 'กำลังสแกน',
    skipped: 'ข้าม',
    errors: 'ผิดพลาด',
    noSlipsFound: 'ไม่พบสลิปในรูปที่เลือก',
    found: 'พบ',
    slips: 'สลิป',
    selectAll: 'เลือกทั้งหมด',

    billScanning: 'AI กำลังอ่านใบเสร็จ…',
    billScanningHint: 'กำลังระบุรายการสินค้าและหมวดหมู่',
    billStoreGeneric: 'ร้านค้าทั่วไป',
    billNotFound: 'ไม่พบข้อมูลบิลหรือใบเสร็จในรูปนี้ กรุณาลองใหม่',
    billGenericError: 'เกิดข้อผิดพลาด กรุณาลองใหม่',
    billPartialTitle: 'อ่านได้ไม่ครบ ({n} รายการ)',
    billPartialDesc: 'บิลมีรายการมาก AI อ่านได้บางส่วน ยอดรวมคำนวณจากรายการที่อ่านได้ กรุณาตรวจสอบก่อนบันทึก',
    billItemsTitle: 'รายการสินค้า',
    billItemsHint: 'แตะเพื่อยกเว้น · แก้ไขหมวดหมู่ได้',
    billDiscount: 'ส่วนลดรวม',
    billTax: 'ภาษี',
    billGrandTotal: 'ยอดรวม',
    billPaidWith: 'ชำระด้วย',
    billSaveAs: 'บันทึกเป็น',
    billSaveSingle: 'รวมเป็นรายการเดียว',
    billSaveCategory: 'แยกตามหมวดหมู่',
    billSaveItemized: 'แยกทุกรายการ',
    billSummary: 'รวม {n} รายการ · {cur} {total}',
    localeTag: 'th-TH',

    // ── Paywall / Upgrade / FeatureGate ──
    pwTitle: 'อัปเกรด MoneyMa',
    pwSubtitle: 'ปลดล็อกทุกฟีเจอร์ ทั้งสแกนสลิปและบิลด้วย AI และ Cloud Sync',
    pwSubtitleFeature: 'ปลดล็อก {feature} และฟีเจอร์ Pro ที่เหลือ',
    pwAriaLabel: 'เลือกแพลน',
    pwClose: 'ปิด',
    pwMonthly: 'รายเดือน',
    pwYearly: 'รายปี',
    pwSave: 'ประหยัด {pct}%',
    pwRecommended: 'แนะนำ',
    pwCurrent: 'ปัจจุบัน',
    pwFree: 'ฟรี',
    pwPerYear: 'ปี',
    pwPerMonth: 'เดือน',
    pwMonthlyEquiv: '฿{n}/เดือน',
    pwCompare: 'เปรียบเทียบฟีเจอร์',
    pwProcessing: 'กำลังดำเนินการ…',
    pwCurrentPlanBtn: 'แผนปัจจุบัน',
    pwUseFree: 'ใช้แบบฟรี',
    pwStartPlan: 'เริ่มใช้ {plan}',
    pwRestoring: 'กำลังกู้คืน…',
    pwRestore: 'กู้คืนการซื้อ',
    pwManageSub: 'จัดการการสมัครสมาชิก',
    pwPaymentNote: 'ชำระเงินผ่าน {store} · ยกเลิกได้ทุกเมื่อ',
    pwNoPurchase: 'ไม่พบการซื้อที่บันทึกไว้',
    pwUnlimited: 'ไม่จำกัด',
    pwTxPerMonth: 'ธุรกรรมต่อเดือน',
    pwTx50: '50 รายการ',
    pwAiScanSlip: 'สแกนสลิปด้วย AI',
    pwAiScanBill: 'สแกนบิลและใบเสร็จด้วย AI',
    pwScansPerMonth: '200 สแกน/เดือน',
    pwBudget1: '1 หมวด',
    pwMultiWorkspace: 'หลาย Workspace',

    upgradeTitle: 'ปลดล็อกความสามารถเต็มรูปแบบ',
    upgradeDesc: 'อัปเกรดเพื่อบันทึกได้ไม่จำกัดและซิงค์ขึ้นคลาวด์',
    upgradeCta: 'อัปเกรดเป็น Pro',
    maybeLater: 'ไว้ทีหลัง',
    gotIt: 'รับทราบ',
    featUnlimitedTx: 'บันทึกธุรกรรมได้ไม่จำกัด จากเดิม 50 รายการต่อเดือน',
    featCloudSync: 'Cloud Sync ซิงค์ข้อมูลข้ามอุปกรณ์',
    featExcel: 'ส่งออก Excel และ PDF ได้ไม่จำกัด',
    featUnlimitedBudgets: 'ตั้งงบประมาณได้ทุกหมวด จากเดิม 1 หมวด',
    featAlert: 'แจ้งเตือนเมื่อใช้จ่ายเกินงบ',
    featVisuals: 'กราฟวิเคราะห์และเปรียบเทียบเชิงลึก',

    fgAiScanSlip: 'สแกนสลิปด้วย AI',
    fgAiScanBill: 'สแกนบิลด้วย AI',
    fgAutoScan: 'สแกนอัตโนมัติ',
    fgUnlimitedTx: 'ธุรกรรมไม่จำกัด',
    fgMultiWorkspace: 'หลาย Workspace',
    fgAvailableIn: '{feature} ใช้ได้ในแพลน {plan}',
    fgOnlyIn: 'ฟีเจอร์นี้ใช้ได้เฉพาะแพลน {plan}',
    fgUpgradeTo: 'อัปเกรดเป็น {plan}',
    fgUpgradeArrow: 'อัปเกรด',
    fgUnlock: 'ปลดล็อก {feature}',

    // ── ไฟล์ที่ส่งออก (PDF / CSV / TXT) ──
    expReportTitle: 'MoneyMa — รายงานธุรกรรม',
    expPeriod: 'ช่วงเวลา',
    expGenerated: 'สร้างเมื่อ',
    expOverview: 'สรุปภาพรวม',
    expTotalIncome: 'รายรับรวม',
    expTotalExpense: 'รายจ่ายรวม',
    expNet: 'ยอดสุทธิ',
    expNegative: 'ติดลบ',
    expCount: 'จำนวนรายการ',
    expTransactions: 'รายการธุรกรรม',
    expColDate: 'วันที่',
    expColType: 'ประเภท',
    expColCategory: 'หมวดหมู่',
    expColDescription: 'รายละเอียด',
    expColAmount: 'จำนวนเงิน',
    expIncome: 'รายรับ',
    expExpense: 'รายจ่าย',
    expTotal: 'รวม',

    // ── ชื่อแพลนและป้าย ──
    planFree: 'ฟรี',
    planPro: 'โปร',
    planBusiness: 'ธุรกิจ',
    planLifetime: 'ตลอดชีพ',
    badgeRecommended: 'แนะนำ',
    badgeOneTime: 'จ่ายครั้งเดียว',

    // ── ข้อผิดพลาดระบบชำระเงิน ──
    billNotConfigured: 'ระบบชำระเงินในแอปยังไม่พร้อมใช้งานชั่วคราว กรุณาลองใหม่อีกครั้งภายหลัง',
    billNoOfferings: 'ยังไม่มีแพ็กเกจให้เลือกจาก App Store / Google Play โปรดลองใหม่ภายหลัง',
    billStoreError: 'เชื่อมต่อ App Store / Google Play ไม่สำเร็จ ตรวจสอบการเชื่อมต่อหรือการเข้าสู่ระบบบัญชี Store',
    billInitFailed: 'เริ่มระบบชำระเงินไม่สำเร็จ กรุณาลองใหม่',
    billNoPackages: 'ยังไม่มีแพ็กเกจให้เลือกในขณะนี้',
    billPackageNotFound: 'ไม่พบแพ็กเกจสำหรับ {plan} {period} (มีในระบบ: {list})',

    // ── ข้อผิดพลาดโควตา AI ──
    quotaDailyFull: 'โควตาสแกนฟรีรายวันเต็มแล้ว ({n} ครั้งต่อวัน) อัปเกรดเพื่อสแกนต่อ',
    quotaMonthlyFull: 'โควตาสแกนเต็มแล้ว ({n} ครั้งต่อเดือน)',
    quotaNeedLogin: 'กรุณาเข้าสู่ระบบก่อนใช้งานฟีเจอร์สแกน',
    quotaCheckFailed: 'ตรวจสอบโควตา AI ไม่สำเร็จ',
    quotaBusy: 'โควตาใช้งาน AI เต็มชั่วคราว รอสักครู่แล้วลองใหม่',
    scanNoSlip: 'ไม่พบข้อมูลสลิปในรูปนี้ กรุณาลองใหม่',
    scanGenericError: 'เกิดข้อผิดพลาด กรุณาลองใหม่',
    autoScanError: 'เกิดข้อผิดพลาดระหว่างสแกนอัตโนมัติ',
    aiSafetyBlocked: 'AI หยุดทำงานเพราะรูปอาจมีเนื้อหาที่ไม่ปลอดภัย ลองใช้รูปที่ชัดกว่านี้',
    billLongWarn: 'บิลยาว อ่านได้ {n} รายการ (อาจไม่ครบ)',
    billTooManyItems: 'บิลมีรายการมากเกินไปจน AI อ่านได้ไม่ครบ ({n} รายการ)\nแนะนำ: ถ่ายรูปแยกเป็นสองส่วนแล้วสแกนทีละส่วน',
    billNoJson: 'ไม่พบข้อมูลรูปแบบ JSON ในคำตอบจาก AI',
    billParseError: 'อ่านข้อมูลบิลไม่สำเร็จ (JSON parse error): {msg}',
    billPaidBy: 'จ่ายด้วย {method}',
    billItemCount: '{n} รายการ',

    // ── หมวดสินค้าในบิล ──
    catFoodFresh: 'อาหารสด',
    catFoodPackaged: 'อาหารสำเร็จรูป',
    catFoodSnack: 'ขนมและเครื่องดื่ม',
    catHousehold: 'ของใช้ในบ้าน',
    catPersonalCare: 'ของใช้ส่วนตัว',
    catHealth: 'ยาและสุขภาพ',
    catAlcohol: 'เครื่องดื่มแอลกอฮอล์',
    catOther: 'อื่น ๆ',

    registerConfirmSent: 'ระบบส่งอีเมลยืนยันตัวตนไปให้แล้ว กรุณาเปิดอีเมลและคลิกลิงก์เพื่อเปิดใช้งานบัญชี',
    premiumHint: 'อัปเกรดเพื่อปลดล็อกฟีเจอร์เพิ่มเติม',

    // ─── Inventory & POS (Business) ───
    navInventory: 'สต็อก & POS',
    navInventoryHint: 'จัดการคลังสินค้าและออกบิล',
    posEyebrow: 'ระบบสต็อก & POS ธุรกิจ',
    inventoryTitle: 'คลังสินค้า และระบบซื้อขาย',
    inventorySubtitle: 'Business POS & Inventory Management',
    tabInventory: '📦 คลังสินค้า',
    tabPos: '🛒 ขายออก / POS',
    tabPo: '🚚 ซื้อเข้า / PO',
    businessTrialTitle: 'คุณได้รับสิทธิ์ทดลองใช้งาน Business Plan ฟรี 7 วัน',
    businessTrialDesc: 'เปิดใช้งานระบบคลังสินค้า, POS ขายออก, สแกนสินค้าด้วย AI และออกเอกสารได้ครบทุกฟังก์ชัน',
    businessTrialDetailsBtn: '✨ รายละเอียด Business Plan',
    gatePosTitle: '🔒 ระบบคลังสินค้า และระบบ POS ขายหน้าร้าน',
    gatePosDesc: 'อัปเกรดเป็นแผน Business เพื่อเปิดใช้งานระบบคลังสินค้า ตัดสต็อกอัตโนมัติ ออกใบกำกับภาษี และระบบขายหน้าร้านครบวงจร',
    tabPeriodicReport: '📊 รายงานประจำงวด',
    thermalPrinter: '🖨️ เครื่องพิมพ์ใบเสร็จ (Thermal / Standard Printer):',
    printerReady: 'เชื่อมต่อเรียบร้อย',
    autoPrintReceiptLabel: 'พิมพ์สลิปอัตโนมัติเมื่อชำระเงิน',
    testPrintBtn: '🧪 ทดสอบพิมพ์สลิป',
    totalProducts: 'สินค้าทั้งหมด',
    statTotalProducts: 'สินค้าทั้งหมด',
    statItemsCount: '{n} รายการ',
    statInStock: '{n} ชิ้นในสต็อก',
    statCostVal: 'มูลค่าทุนรวม (Cost)',
    statAllCost: 'ต้นทุนสินค้าทั้งหมด',
    statRetailVal: 'มูลค่าขายรวม (Retail)',
    statEstProfit: 'กำไรคาดการณ์ ฿{val}',
    statLowStockAlert: 'เตือนสินค้าใกล้หมด',
    statBelowMin: 'ต่ำกว่าระดับขั้นต่ำ',
    itemsInStockHeader: 'รายการสินค้าในสต็อก',
    btnAiCameraScan: 'ถ่ายรูป',
    btnAiFileScan: 'จากไฟล์',
    aiScanningState: 'กำลังสแกน...',
    aiVisionModalHeader: 'ให้ AI เติมข้อมูลจากรูป',
    prodImageLabel: 'รูปสินค้า',
    prodImageNone: 'ยังไม่มีรูป',
    prodImagePick: 'เลือกรูป / ถ่ายรูป',
    prodImageUrlHint: 'หรือวางลิงก์รูป',
    prodStockLegend: 'จำนวนในคลัง',
    prodStockTotal: 'รวม',
    prodStockUnit: 'ชิ้น',
    aiVisionModalSub: 'ถ่ายภาพจากกล้องหรือเลือกไฟล์รูปภาพเพื่อเติมข้อมูลอัตโนมัติ',
    addNewProduct: '+ เพิ่มสินค้าใหม่',
    editProductTitle: 'แก้ไขสินค้า',
    addProductTitle: 'เพิ่มสินค้าใหม่ในคลัง',
    thSku: 'รหัส SKU',
    thProdName: 'ชื่อสินค้า',
    thCostPrice: 'ราคาทุน (฿)',
    thSellPrice: 'ราคาขาย (฿)',
    thStockRemain: 'สต็อกคงเหลือ',
    thStatus: 'สถานะ',
    thManage: 'จัดการ',
    statusOut: 'สินค้าหมด',
    statusLow: 'สต็อกต่ำ',
    statusNormal: 'ปกติ',
    posSearchPlaceholder: '🔍 ค้นหาสินค้าด้วยชื่อ หรือ SKU...',
    cartTitle: '🛒 ตระกร้าสินค้า (Cart)',
    posCartEmpty: 'ยังไม่มีสินค้าในตะกร้า คลิกเลือกสินค้าฝั่งซ้าย',
    customerNameLabel: 'ชื่อลูกค้า / บริษัท',
    taxIdLabel: 'เลขประจำตัวผู้เสียภาษี Tax ID',
    supplierNameLabel: 'ชื่อผู้จัดจำหน่าย / ซัพพลายเออร์',
    posSubtotal: 'ยอดรวมสินค้า:',
    posDiscount: 'ส่วนลด (฿):',
    posVat: 'ภาษี VAT (%):',
    posVatExempt: '0% (ยกเว้น VAT)',
    posVatIncluded: '7% (Vat ในระบบ)',
    posGrandTotal: 'ยอดชำระสุทธิ:',
    completeSaleBtn: '🧾 ชำระเงิน & พิมพ์ใบเสร็จรับเงิน',
    posSelectItemsToBuy: 'เลือกสินค้าที่ต้องการสั่งซื้อเข้าสต็อก',
    poCartTitle: '🚚 รายการสั่งซื้อเข้าสต็อก (PO)',
    poEmpty: 'ยังไม่มีสินค้าในใบสั่งซื้อ คลิกเลือกสินค้าฝั่งซ้าย',
    poSupplierPlaceholder: 'ชื่อผู้จัดจำหน่าย / ซัพพลายเออร์',
    poSupplierTaxIdPlaceholder: 'เลขผู้เสียภาษี ซัพพลายเออร์',
    poUnitCost: 'ทุนซื้อ: ฿',
    poUnitCostLabel: 'ทุนซื้อ',
    receiptImportTitle: 'ใบเสร็จจากร้านค้า',
    receiptImportLoading: 'กำลังโหลดใบเสร็จ…',
    receiptImportItems: '{n} รายการ',
    receiptImportSave: 'บันทึกเป็นรายจ่าย',
    receiptImportClose: 'ปิด',
    receiptImportSaved: 'บันทึกเป็นรายจ่ายแล้ว',
    receiptImportAlready: 'ใบเสร็จนี้บันทึกไว้แล้ว',
    receiptImportNotFound: 'ไม่พบใบเสร็จนี้',
    receiptImportOffline: 'เชื่อมต่อไม่ได้ ลองใหม่อีกครั้ง',
    receiptImportUnavailable: 'ยังเปิดใบเสร็จนี้ไม่ได้ ลองใหม่ภายหลัง',
    receiptImportRetry: 'ลองใหม่',
    receiptImportDesc: 'ใบเสร็จจาก {shop}',
    receiptImportUnknownShop: 'ร้านค้า',
    receiptImportHint: 'จะบันทึกเป็นรายจ่ายหมวด Shopping แก้ไขได้ภายหลัง',
    poTotalExpense: 'ยอดสั่งซื้อรวม (Expense):',
    completePoBtn: '📥 รับสินค้าเข้าสต็อก & บันทึกรายจ่าย',
    prodModalMinStock: 'เตือนเมื่อเหลือ',

    // ─── Statement Builder ───
    customizeStatementDesc: 'เลือกคอลัมน์ ใส่โลโก้/เลขผู้เสียภาษี และออกรายงานสเตทเมนต์ PDF/HTML มืออาชีพ',
    statementModalTitle: 'ปรับแต่งแบบฟอร์มรายงาน & สเตทเมนต์',
    statementModalEyebrow: 'เครื่องมือสร้างรายงานการเงิน',
    docDetails: '1. รูปแบบและข้อมูลส่วนหัวเอกสาร',
    exportFormat: 'รูปแบบไฟล์ที่ต้องการส่งออก',
    fmtPdf: '📄 สเตทเมนต์ทางการ (PDF/Print)',
    fmtPdfDesc: 'มีโลโก้ ข้อมูลบริษัท ยอดคงเหลือสะสม',
    fmtExcel: '📊 ไฟล์ Excel (.xlsx)',
    fmtExcelDesc: 'นำไปคำนวณต่อใน Excel / Spreadsheet',
    fmtCsv: '📁 ไฟล์ CSV (.csv)',
    fmtCsvDesc: 'นำเข้าซอฟต์แวร์บัญชีอื่น',
    fmtText: '📝 ข้อความ (.txt)',
    fmtTextDesc: 'รายงานข้อความแบบย่อ',
    docTitleLabel: 'หัวข้อเอกสารรายงาน',
    companyNameLabel: 'ชื่อบริษัท / องค์กร',
    addressLabel: 'ที่อยู่',
    phoneLabel: 'เบอร์โทรศัพท์',
    footerNoteLabel: 'หมายเหตุท้ายเอกสาร',
    tableColumnsSection: '2. เลือกคอลัมน์ในตาราง',
    dateFilterSection: '3. กรองช่วงเวลา',
    colDate: 'วันที่',
    colType: 'ประเภท',
    colCategory: 'หมวดหมู่',
    colDescription: 'รายการ / คำอธิบาย',
    colAmount: 'จำนวนเงิน',
    colBalance: 'ยอดสะสมสุทธิ',
    livePreviewTitle: '👀 ตัวอย่างสเตทเมนต์ (Live Preview)',
    runExportBtn: '🚀 พิมพ์ / ส่งออกไฟล์ ({fmt})',
    defaultDocTitle: 'สเตทเมนต์ทางการเงิน (Business Statement)',
    defaultCompanyName: 'บริษัท มะนี่มา จำกัด (MoneyMa Co., Ltd.)',
    defaultAddress: '88/99 อาคารการเงิน ถนนสุขุมวิท กรุงเทพฯ 10110',
    defaultFooterNote: 'รายงานนี้ออกโดยระบบบัญชีการเงิน MoneyMa เพื่อใช้เป็นหลักฐานทางธุรกิจ',
};
